import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './data-support.paths';
import { dataSupportApp } from './data-support';

/**
 * @deprecated This app is pending removal from the platform.
 */
export const DataSupportApp: SpherePlatformApp = {
    APP: dataSupportApp,
    PATHS
};
